import { render, staticRenderFns } from "./RsaConfigurazioneTipoPrestazioniViewComponent.vue?vue&type=template&id=6665dd97&scoped=true"
import script from "./RsaConfigurazioneTipoPrestazioniViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTipoPrestazioniViewComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaConfigurazioneTipoPrestazioniViewComponent.vue?vue&type=style&index=0&id=6665dd97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665dd97",
  null
  
)

export default component.exports